export default "__VITE_ASSET__D0gb3h4F__"